import axios from 'axios';
import qs from 'qs';

class API {
	signup(reqData) {
		const { email, password, recaptcha } = reqData;
		const data = qs.stringify({ email, password, response: recaptcha });
		return axios({
			method: 'post',
			url: `${process.env.REACT_APP_API}/v3/register/email`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			data,
		});
	}

	signin(reqData) {
		const { email, password, recaptcha } = reqData;
		const data = qs.stringify({ email, password, response: recaptcha });
		return axios({
			method: 'post',
			url: `${process.env.REACT_APP_API}/v3/login/email`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			data,
		});
	}

	getUserProfile(token) {
		return axios({
			method: 'get',
			url: `${process.env.REACT_APP_API}/v3/currentUser`,
			headers: {
				Authorization: `Bearer ${token || localStorage.token}`,
			},
		});
	}	

	// createCheckoutSession(token, priceId) {
	// 	const data = {'priceId': priceId};
	// 	return axios({
	// 		method: 'post',
	// 		url: `${process.env.REACT_APP_API}/v3/create-checkout-session`,
	// 		headers: {
	// 			Authorization: `Bearer ${token || localStorage.token}`,
	// 		},
	// 		data,
	// 	});
	// }

	getSubscriptionInfo(token) {
		return axios({
			method: 'get',
			url: `${process.env.REACT_APP_API}/v3/subscription`,
			headers: {
				Authorization: `Bearer ${token || localStorage.token}`,
			},
		});
	}

	updateSubscription(reqData, token) {
		const { ip } = reqData;
		const data = qs.stringify({ ip });
		return axios({
			method: 'post',
			url: `${process.env.REACT_APP_API}/v3/subscription`,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				Authorization: `Bearer ${token || localStorage.token}`,
			},
			data,
		});
	}
}

export default new API();
